import moment from "moment";
import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import ReactTable, { RowInfo } from "react-table";
import { bindActionCreators } from "redux";
import { InlineLoading } from "src/components/common";
import { Link } from "src/components/routing";
import { PAGE_SIZE_OPTIONS } from "src/constants/reactTableConstants";
import { CommitteeMeetingAttendancesBreadcrumbs } from "src/helpers/breadcrumbHelper";
import RouterHoc, { IRouterActions, IRouterProps } from "src/hoc/RouterHoc";
import * as CommitteeMeetingActions from "../../../actions/committeeMeeting";
import * as CommitteeMeetingAttendanceActions from "../../../actions/committeeMeetingAttendance";
import * as CommitteeActions from "../../../actions/committees";
import * as NavigationActions from "../../../actions/navigation";
import * as PagingActions from "../../../actions/pages/pagingPage";
import { RestrictedLayout } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { CommitteeMeetingSubMenu } from "../../../helpers/subMenuHelper";
import { IFormFilter, ITmdState } from "../../../reducers/index";

import "./CommitteeMeetingAttendancesPage.scss";

interface ICommitteeMeetingAttendancesPageParams {
    committeeId: number;
    committeeMeetingId: number;
}

interface ICommitteeMeetingAttendancesPageProps
    extends IRouterProps<ICommitteeMeetingAttendancesPageParams> {
    committeeId: number;
    committeeMeetingId: number;

    // From state
    formFilter: IFormFilter;
    committee: Dtos.Committee;
    committeeMeeting: Dtos.CommitteeMeeting;
    committeeMeetingAttendances: Dtos.CommitteeMeetingAttendance[] | undefined;
    lookups: Dtos.Lookup[];

    loadingCommittee: boolean;
    loadCommitteeSuccess: boolean;
    loadCommitteeFailure: boolean;
    loadCommitteeErrorCode: string;

    loadingCommitteeMeeting: boolean;
    loadCommitteeMeetingSuccess: boolean;
    loadCommitteeMeetingFailure: boolean;
    loadCommitteeMeetingErrorCode: string;

    loadingCommitteeMeetingAttendances: boolean;
    loadCommitteeMeetingAttendancesSuccess: boolean;
    loadCommitteeMeetingAttendancesFailure: boolean;
    loadCommitteeMeetingAttendancesErrorCode: string;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];

    pageSize: number;
}

interface ICommitteeMeetingAttendancesPageActions extends IRouterActions {
    clearCommitteeMeetingAttendances: CommitteeMeetingAttendanceActions.ICommitteeMeetingAttendanceClearActionCreator;
    loadCommitteeMeetingAttendances: CommitteeMeetingAttendanceActions.ICommitteeMeetingAttendanceLoadByCommitteeMeetingIdActionCreator;

    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

    clearCommittee: CommitteeActions.ICommitteeClearActionCreator;
    loadCommittee: CommitteeActions.ICommitteeLoadByIdActionCreator;

    clearCommitteeMeeting: CommitteeMeetingActions.ICommitteeMeetingClearActionCreator;
    loadCommitteeMeeting: CommitteeMeetingActions.ICommitteeMeetingLoadByIdActionCreator;

}

type CommitteeMeetingAttendancesPageProps =
    ICommitteeMeetingAttendancesPageProps &
        ICommitteeMeetingAttendancesPageActions;

class CommitteeMeetingAttendancesPage extends React.PureComponent<
    CommitteeMeetingAttendancesPageProps,
    any
> {
    constructor(props: CommitteeMeetingAttendancesPageProps) {
        super(props);
        this.clearCommittee = this.clearCommittee.bind(this);
        this.toggleExportMenu = this.toggleExportMenu.bind(this);

        this.state = {
            exportToggle: false,
        };
    }

    componentDidMount() {
        const {
            loadCommitteeMeetingAttendances,
            committeeId,
            committeeMeetingId,
            setBreadcrumbs,
            loadCommittee,
            loadCommitteeMeeting
        } = this.props;
        

        if (committeeId) {
            loadCommittee(committeeId);
        }
        if (committeeMeetingId) {
            loadCommitteeMeeting(committeeMeetingId);
            loadCommitteeMeetingAttendances(committeeMeetingId);
        }

        if (committeeId && committeeMeetingId) {
            setBreadcrumbs(
                CommitteeMeetingAttendancesBreadcrumbs(
                    committeeId,
                    committeeMeetingId
                )
            );
        }
    }

    componentDidUpdate(
        prevProps: CommitteeMeetingAttendancesPageProps,
        _prevState
    ) {
        const {
            committee,
            committeeId,
            committeeMeeting,
            loadCommittee,
            setDrawerItems,
            setBreadcrumbs,
            permissions,
            committeeMeetingId,
            loadCommitteeMeeting,
            loadCommitteeFailure,
            loadCommitteeMeetingAttendancesFailure,
            loadCommitteeMeetingFailure,
            loadCommitteeErrorCode,
            loadCommitteeMeetingErrorCode,
            loadCommitteeMeetingAttendancesErrorCode,
            navigate,
        } = this.props;

        if (loadCommitteeFailure) {
            navigate(`/error/${loadCommitteeErrorCode}`);
        }
        if (loadCommitteeMeetingAttendancesFailure) {
            navigate(`/error/${loadCommitteeMeetingAttendancesErrorCode}`);
        }
        if (loadCommitteeMeetingFailure) {
            navigate(`/error/${loadCommitteeMeetingErrorCode}`);
        }

        if (committeeMeeting) {
            setDrawerItems(
                CommitteeMeetingSubMenu(committeeMeeting, permissions)
            );
        }

        if (
            committeeId &&
            committeeMeetingId &&
            committee &&
            committeeMeeting
        ) {
            setBreadcrumbs(
                CommitteeMeetingAttendancesBreadcrumbs(
                    committeeId,
                    committeeMeetingId,
                    committee?.name,
                    this.getCommitteeMeetingName(committeeMeeting)
                )
            );
        }

        if (committeeId && prevProps.committeeId != committeeId) {
            loadCommittee(committeeId);
        }

        if (
            committeeMeetingId &&
            prevProps.committeeMeetingId != committeeMeetingId
        ) {
            loadCommitteeMeeting(committeeMeetingId);
        }
    }

    componentWillUnmount() {
        this.clearCommittee();
    }

    clearCommittee() {
        this.props.clearCommittee();
        this.props.clearCommitteeMeeting();
        this.props.clearCommitteeMeetingAttendances();
    }

    toggleExportMenu() {
        this.setState({
            exportToggle: !this.state.exportToggle,
        });
    }

    showCommitteeMeetingAttendances(): boolean {
        const {
            loadingCommitteeMeetingAttendances,
            loadCommitteeMeetingAttendancesSuccess,
        } = this.props;

        if (
            !loadingCommitteeMeetingAttendances &&
            loadCommitteeMeetingAttendancesSuccess
        ) {
            return true;
        }

        return false;
    }

    getCommitteeMeetingName(committeeMeeting: Dtos.CommitteeMeeting): string {
        let result = "";

        if (committeeMeeting.meetingDate) {
            result += moment(
                committeeMeeting.meetingDate,
                "YYYY-MM-DD HH:mm:ss.SSSSSSS Z"
            ).format("DD/MM/YYYY");
        }

        if (committeeMeeting.location) {
            result +=
                result !== ""
                    ? ` - ${committeeMeeting.location}`
                    : committeeMeeting.location;
        }

        if (committeeMeeting.room) {
            result +=
                result !== ""
                    ? ` - ${committeeMeeting.room}`
                    : committeeMeeting.room;
        }

        if (committeeMeeting.time) {
            result +=
                result !== ""
                    ? ` - ${committeeMeeting.time}`
                    : committeeMeeting.time;
        }

        return result;
    }

    render() {
        const {
            loadingCommittee,
            loadingCommitteeMeeting,
            loadingCommitteeMeetingAttendances,
        } = this.props;

        return (
            <RestrictedLayout
                permission={Dtos.Permission.CommitteeMeetingAttendanceView}
                loading={
                    loadingCommittee ||
                    loadingCommitteeMeeting ||
                    loadingCommitteeMeetingAttendances
                }
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const { permissions, committeeId, committeeMeetingId } = this.props;

        const canCreate = AuthenticationHelper.hasPermission(
            permissions,
            Dtos.Permission.CommitteeMeetingAttendanceCreate
        );

        return (
            <div>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>Attendance</h1>
                    </div>
                    <div className="col" style={{ textAlign: "right" }}>
                        {canCreate && (
                            <>
                                <Link
                                    className={"btn btn-primary"}
                                    url={`/committees/${committeeId}/meetings/${committeeMeetingId}/attendances/create`}
                                >
                                    Add
                                </Link>
                            </>
                        )}
                    </div>
                </div>
                {!this.showCommitteeMeetingAttendances() ? (
                    <InlineLoading absoluteCenter={true} size={50} />
                ) : null}
                {this.showCommitteeMeetingAttendances() ? (
                    <div className="card">
                        <div className="patient-tables">
                            {this.createTable()}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    createTable() {
        const {
            committeeId,
            committeeMeetingId,
            committeeMeetingAttendances,
            pageSize,
            setPageSize,
        } = this.props;

        if (
            !committeeMeetingAttendances ||
            committeeMeetingAttendances.length == 0
        ) {
            return (
                <div className="card card-shadow p-3">
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>There are currently no attendance to view.</span>
                    </div>
                </div>
            );
        }

        const showPagination = committeeMeetingAttendances.length > pageSize;

        return (
            <div className="table-wrapper">
                <ReactTable
                    data={committeeMeetingAttendances}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    defaultPageSize={
                        showPagination
                            ? pageSize
                            : committeeMeetingAttendances.length
                    }
                    pageSize={
                        showPagination
                            ? pageSize
                            : committeeMeetingAttendances.length
                    }
                    showPagination={showPagination}
                    className="-striped -highlight -clickable"
                    noDataText="There are currently no attendance to display"
                    resizable={false}
                    onPageSizeChange={(val) => setPageSize(val)}
                    getTdProps={(
                        state,
                        rowInfo: RowInfo,
                        _column,
                        _instance
                    ) => {
                        return {
                            onClick: (e, handleOriginal) => {
                                const url = `/committees/${committeeId}/meetings/${committeeMeetingId}/attendances/${rowInfo.original.id}/details`;
                                this.props.navigate(url);

                                if (handleOriginal) {
                                    handleOriginal();
                                }
                            },
                        };
                    }}
                    defaultSorted={[
                        {
                            id: "personnel.display",
                            desc: false,
                        },
                    ]}
                    columns={[
                        {
                            id: "id",
                            Header: " ",
                            accessor: "id",
                            maxWidth: 50,
                            Cell: (_props) => (
                                <FontAwesomeIcon
                                    size="lg"
                                    icon={
                                        FontAwesomeIcons.Duotone.CLIPBOARDUSER
                                    }
                                    fixedWidth
                                />
                            ),
                        },
                        {
                            id: "personnel.displayWithSalutation",
                            Header: "Name",
                            accessor: "personnel.displayWithSalutation",
                        },
                        {
                            id: "committeeMeetingAttendanceStatus.value",
                            Header: "Attending",
                            accessor: "committeeMeetingAttendanceStatus.value",
                        },
                        {
                            id: "comment",
                            Header: "Comment",
                            accessor: "comment",
                        },
                        {
                            id: "personnel.display",
                            Header: "",
                            accessor: "personnel.display",
                            maxWidth: 0,
                            Cell: (_props) => <></>,
                        },
                    ]}
                />
            </div>
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: CommitteeMeetingAttendancesPageProps
): ICommitteeMeetingAttendancesPageProps => {
    let committee: Dtos.Committee | undefined = !(
        state.committees.formData instanceof Array
    )
        ? state.committees.formData
        : undefined;
    let committeeMeeting: Dtos.CommitteeMeeting | undefined = !(
        state.committeeMeeting.formData instanceof Array
    )
        ? state.committeeMeeting.formData
        : undefined;
    let committeeMeetingAttendances:
        | Dtos.CommitteeMeetingAttendance[]
        | undefined =
        state.committeeMeetingAttendance.formData instanceof Array
            ? state.committeeMeetingAttendance.formData
            : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        history: ownProps.history,
        location: ownProps.location,
        match: ownProps.match,

        committeeMeetingAttendances: committeeMeetingAttendances,
        formFilter: state.trials.formFilter,
        lookups: state.committeeMeetingAttendance.lookups,

        loadingCommitteeMeetingAttendances:
            state.committeeMeetingAttendance.loadState &&
            state.committeeMeetingAttendance.loadState.status ==
                RequestState.Pending,
        loadCommitteeMeetingAttendancesSuccess:
            state.committeeMeetingAttendance.loadState &&
            state.committeeMeetingAttendance.loadState.status ==
                RequestState.Success,
        loadCommitteeMeetingAttendancesFailure:
            state.committeeMeetingAttendance.loadState &&
            state.committeeMeetingAttendance.loadState.status ==
                RequestState.Failure,
        loadCommitteeMeetingAttendancesErrorCode:
            state.committeeMeetingAttendance.loadState.errorCode,

        committeeId: ownProps.match.params.committeeId,
        committee: committee!,

        committeeMeetingId: ownProps.match.params.committeeMeetingId,
        committeeMeeting: committeeMeeting!,

        loadingCommittee:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Pending,
        loadCommitteeSuccess:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Success,
        loadCommitteeFailure:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Failure,
        loadCommitteeErrorCode: state.committees.loadState.errorCode,

        loadingCommitteeMeeting:
            state.committeeMeeting.loadState &&
            state.committeeMeeting.loadState.status == RequestState.Pending,
        loadCommitteeMeetingSuccess:
            state.committeeMeeting.loadState &&
            state.committeeMeeting.loadState.status == RequestState.Success,
        loadCommitteeMeetingFailure:
            state.committeeMeeting.loadState &&
            state.committeeMeeting.loadState.status == RequestState.Failure,
        loadCommitteeMeetingErrorCode:
            state.committeeMeeting.loadState.errorCode,

        user: state.user.data,
        permissions: permissions,

        pageSize: state.pagingPage.pageSize,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: CommitteeMeetingAttendancesPageProps
): ICommitteeMeetingAttendancesPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadCommitteeMeetingAttendances: bindActionCreators(
            CommitteeMeetingAttendanceActions.LoadCommitteeMeetingAttendanceByCommitteeMeetingId,
            dispatch
        ),
        clearCommitteeMeetingAttendances: bindActionCreators(
            CommitteeMeetingAttendanceActions.Clear,
            dispatch
        ),

        loadCommittee: bindActionCreators(
            CommitteeActions.LoadCommitteeById,
            dispatch
        ),
        clearCommittee: bindActionCreators(CommitteeActions.Clear, dispatch),

        loadCommitteeMeeting: bindActionCreators(
            CommitteeMeetingActions.LoadCommitteeMeetingById,
            dispatch
        ),
        clearCommitteeMeeting: bindActionCreators(
            CommitteeMeetingActions.Clear,
            dispatch
        ),

        setPageSize: bindActionCreators(
            PagingActions.PageSizeChanged,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default RouterHoc<
    ICommitteeMeetingAttendancesPageParams,
    CommitteeMeetingAttendancesPageProps
>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        CommitteeMeetingAttendancesPage
    ) as unknown as ComponentType<CommitteeMeetingAttendancesPageProps>
) as ComponentType<any>;
